import InputCurrency from './InputCurrency';
export default InputCurrency;
